export default function ($translate) {
    return {
        KEYS: {
            EMPLOYEE_ENROLLED_TO_COURSE: 'EMPLOYEE_ENROLLED_TO_COURSE',
            EMPLOYEE_HAS_NOT_PASSED_TRAINING_MODULE: 'EMPLOYEE_HAS_NOT_PASSED_TRAINING_MODULE',
            TRAINING_EDITED: 'TRAINING_EDITED',
            CERTIFICATE_EXPIRING: 'CERTIFICATE_EXPIRING'
        },
        LABELS: {
            EMPLOYEE_ENROLLED_TO_COURSE: $translate.instant('events.Employee enrolled to course'),
            EMPLOYEE_HAS_NOT_PASSED_TRAINING_MODULE: $translate.instant('events.Employee has not passed training module'),
            TRAINING_EDITED: $translate.instant('events.Training edited'),
            CERTIFICATE_EXPIRING: $translate.instant('events.Certificate expiring')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/event/trigger/index.js